const getResultsListWidth = layout => {
  const result =
    layout.width > 695
      ? { minWidth: 695, maxWidth: 695 }
      : { minWidth: 300, maxWidth: layout.width - 20 };
  return result;
};

export default getResultsListWidth;
